/*
 * @Description:
 * @Version:
 * @Author: lixuan
 * @Date: 2020-08-25 11:59:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-13 15:23:50
 */
import axios from 'axios'
import qs from 'qs'
import Cookie from 'js-cookie'
import browser from '@/util/browser'
import { baseUrls } from '../config/service-baseurl'
import { siteLinks } from '../config/website-link'

const { guaguaApp: isApp } = browser
const { protocol } = window.location

export const ENV = Cookie.get('ENV') || 'test'

export const envBaseURL = (serviceKey, hasProtocol = true) => (baseUrls[serviceKey] ? `${hasProtocol ? protocol : ''}${baseUrls[serviceKey][ENV]}` : '')
export const platUrl = baseUrls.plat[ENV]
export function integrateConfig(serviceKey, config = {}) {
    const {
        withCredentials = true, timeout = 60000, paramsSerializer, headers, transformRequest, responseType,
    } = config || {}
    return {
        baseURL: envBaseURL(serviceKey),
        withCredentials: withCredentials && !isApp,
        timeout,
        paramsSerializer: paramsSerializer || ((params) => qs.stringify(params, { arrayFormat: 'brackets' })),
        headers: headers || { 'Content-Type': 'application/json;charset=UTF-8' },
        transformRequest,
        responseType,
    }
}

export function generateNet(serviceKey, config = {}) {
    const iConfig = integrateConfig(serviceKey, config)
    const instance = axios.create(iConfig)
    return (useInterceptors) => {
        useInterceptors && useInterceptors(instance)
        return instance
    }
}

export function generateFormDataNet(serviceKey, config = {}) {
    const iConfig = integrateConfig(serviceKey, {
        ...config,
        ...{
            headers: { 'Content-Type': 'multipart/form-data' },
            transformRequest: [
                (data) => {
                    let formData = new FormData()
                    for (const key in data) {
                        if (data.hasOwnProperty(key)) {
                            formData.append(key, data[key])
                        }
                    }
                    return formData
                },
            ],
        },
    })
    const instance = axios.create(iConfig)
    return (useInterceptors) => {
        useInterceptors && useInterceptors(instance)
        return instance
    }
}

export function generateSiteLink() {
    return Object.keys(siteLinks).reduce((prev, site) => ({ ...prev, ...{ [site]: `${protocol}${siteLinks[site][ENV]}` } }), {})
}

